var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"data-cy":"comments-tile"}},[_c('comment-create',{attrs:{"entity":_vm.entity}}),_c('comment-list',{attrs:{"entity":_vm.entity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }